import axios from "axios";

export function loadBandInfo() {
  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_BACKEND}/current_band_info`, metaData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e);
      });
  });
}
